import { useEffect, useState } from "react";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { CustomerCartItem, VendorCartItem } from "../../components/CustomerCartItem/CustomerCartItem";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import "./index.css";
import { VendorOrderItem } from "../../components/vendorOrderItem/vendorOrderItem";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import { useSeller } from "../../hooks/useSeller";
import ReactLoading from "react-loading";
import InputMask from "react-input-mask";
import { useFilters } from "../../hooks/useFilters";
import { useOrder } from "../../hooks/useOrder";
import { ModalFiltroPedidoVendedor } from "../../components/ModalFiltroPedidoVendedor/ModalFiltroPedidoVendedor";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { VendorCart } from "../../contexts/FiltersContext";

export type jsonCart = {
    name: string;
    price: number;
    unitPrice: number;
    discount: number;
    discountGeral: number;
    promotional_price: number;
    quantity: number;
};

type content = {
    productName: string;
    discount: number;
    discountGeral: number;
};

export type products = {
    price: number;
    content: content;
    discount: number;
};

type status = {
    id: number;
    name: string;
    slug: string;
};

type order = {
    orderidExt: string;
    integration: string;
    deliveryTax: string;
    discountGeneral: string;
    products: products[];
    status: status;
};

type customerAddress = {
    typeAddress: string;
    street: string;
    number: string;
    state: string;
    city: string;
    district: string;
    zipCode: string;
};

type customer = {
    name: string;
    doc: string;
    email: string;
    order: order;
    customerAddress: customerAddress;
};

type vendorCart = VendorCartItem;

type CartStatusOption = {
    select: string;
    value: string;
};



type OrdenationType = {
    name: string;
    type: string;
    order: string
}

export function CustomerCarts() {
    const navigate = useNavigate();
    const { getToken } = usePluginspace();
    const { vendorCart } = useFilters();
    const [customerDocument, setCustomerDocument] = useState<string>('');
    const { getAppConfig } = useAppConfig();
    const { registerAccess } = usePluginspace();
    const [loading, setLoading] = useState(true);
    const [config, setConfig] = useState<ConfigType | void>();
    const [page, setPage] = useState(1);
    const [request, setRequest] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
    const [disableNumber, setDisableNumber] = useState(false);
    const [disableDoc, setDisableDoc] = useState(false);
    const [loadingHeader, setLoadingHeader] = useState(true);

    const [openModalFiltroPedido, setOpenModalFiltroPedido] = useState(false);

    const [orderType, setOrderType] = useState<OrdenationType>({ name: "Mais recente", type: "customerCart.created", order: "DESC" });

    const [isDropdownOpen, setDropdownOpen] = useState(false);


    const orderTypes: OrdenationType[] = [
        { name: "Mais recente", type: "customerCart.created", order: "DESC" },
        { name: "Mais antigo", type: "customerCart.created", order: "ASC" },
        { name: "Status", type: "customerCart.status", order: "DESC" },
    ]


    async function handleMaisRecentesSearchOrders(value: OrdenationType) {
        setLoading(true);
        setOrderType(value);
        setDropdownOpen(false);
        await searchOrders(1, value);
        setLoading(false);
    }

    const [vendorCarts, setvendorCart] = useState<vendorCart[]>([]);

    async function getConfig() {
        //setLoading(true);
        setLoadingHeader(true);
        setConfig(await getAppConfig());
        setLoadingHeader(false);

        setLoading(false);
    }


    function checkBottom(event: any) {
        const bottom =
            event.target.scrollHeight -
            event.target.scrollTop -
            event.target.clientHeight <=
            50;
        if (bottom && !request) {
            if (!hasNextPage) return;
            const newPage = page + 1;
            setPage(newPage);

            setRequest(true);

            searchMoreOrders(newPage, orderType);
        }
    }

    function changeMaskCpf(newDocument: string) {
        const onlyNumbers = newDocument.replace(/\D/g, "");

        if (onlyNumbers.length > 11) {
            setMaskCpfjCnpj("99.999.999/9999-99");
        } else {
            setMaskCpfjCnpj("999.999.999-99");
        }
    }



    async function searchOrders(page?: number, ordenation?: OrdenationType) {
        try {
            if (!(customerDocument && (cnpj.isValid(customerDocument) || cpf.isValid(customerDocument)))) {
                Swal.fire({
                    icon: "warning",
                    title: "Atenção!",
                    text: "Informe o seu CPF ou CNPJ para pesquisar os carrinhos.",
                    confirmButtonText: "OK",
                    showCancelButton: false,
                });
                return;
            }


            setLoading(true);

            setIsLoading(true);

            setPage(page ? page : 1);

            let newPage = page ? page : 1;

            const newOrdernatipon = ordenation ? ordenation : orderType

            let newVendorCart: VendorCart = {
                ...vendorCart,
                cpfCustomer: customerDocument
            };

            // Adiciona horários apenas se initAt/finishAt forem datas sem horário
            if (vendorCart.initAt && /^\d{4}-\d{2}-\d{2}$/.test(vendorCart.initAt)) {
                newVendorCart.initAt = `${vendorCart.initAt} 00:00:00`;
            }
            if (vendorCart.finishAt && /^\d{4}-\d{2}-\d{2}$/.test(vendorCart.finishAt)) {
                newVendorCart.finishAt = `${vendorCart.finishAt} 23:59:59`;
            }

            await api
                .post(`/api/customerCart/filter?take=10&skip=${newPage - 1}&page=${newPage}&order=${newOrdernatipon.order}&field=${newOrdernatipon.type}`,
                    newVendorCart,
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then((response: any) => {
                    const data = response.data

                    if (data) {
                        setHasNextPage(data.meta.hasNextPage);
                        setvendorCart(data.data);
                    }
                    setLoading(false);
                    setIsLoading(false);
                    setRequest(false);
                })
                .catch((err: any) => {
                    setLoading(false);
                    Swal.fire({
                        icon: "warning",
                        title: "Atenção!",
                        text: "Não foi possivel retornar os carrinhos com o filtro informado",
                    });
                    return null;
                });
            setLoading(false);


            setDisableDoc(false);
            setDisableNumber(false);
        } catch (error) {
            console.log(error);
        }
    }

    async function searchMoreOrders(page?: number, ordenation?: OrdenationType) {
        try {
            //setLoading(true);

            setIsLoading(true);

            setPage(page ? page : 1);

            let newPage = page ? page : 1;

            const newOrdernatipon = ordenation ? ordenation : orderType

            const newVendorCart: VendorCart = {
                ...vendorCart,
                cpfCustomer: customerDocument
            }

            await api
                .post(`/api/customerCart/filter?take=10&skip=${newPage - 1}&page=${newPage}&order=${newOrdernatipon.order}&field=${newOrdernatipon.type}`,
                    newVendorCart,
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then((response: any) => {
                    const data = response.data

                    if (data) {
                        setHasNextPage(data.meta.hasNextPage);
                        const newVendorCarts = [...vendorCarts, ...data.data];
                        setvendorCart(newVendorCarts);
                    }
                    setLoading(false);
                    setIsLoading(false);
                    setRequest(false);
                })
                .catch((err: any) => {
                    setLoading(false);
                    Swal.fire({
                        icon: "warning",
                        title: "Atenção!",
                        text: "Não foi possivel retornar os carrinhos com o filtro informado",
                    });
                    return null;
                });
            setLoading(false);


            setDisableDoc(false);
            setDisableNumber(false);
        } catch (error) {
            console.log(error);
        }
    }


    const handleUseCart = (cartGuid: string, urlCart: string) => {
        if (urlCart) {
            // Navegar para o carrinho selecionado na mesma aba
            window.location.href = urlCart + cartGuid;
        } else {
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "URL do carrinho não encontrada.",
                confirmButtonText: "OK"
            });
        }
    };


    useEffect(() => {
        registerAccess("customer-carts");
        getConfig();
    }, []);

    const [searchParams] = useSearchParams();
    const [lastRefresh, setLastRefresh] = useState(searchParams.get("refresh"));


    async function handleSearchOrders() {
        setLoading(true);
        await searchOrders();
        setLoading(false);
    }


    useEffect(() => {
        const interval = setInterval(() => {
            const newRefresh = searchParams.get("refresh");
            if (newRefresh && (newRefresh !== lastRefresh)) {
                //loadFilter()
                setLastRefresh(newRefresh);
                handleSearchOrders()
            }
        }, 100);

        return () => clearInterval(interval);
    }, [searchParams, lastRefresh]);

    return (
        <div className="search-order">
            <div
                className="content-search-order"

            >
                {loading ? (
                    <div style={{ width: "100%", height: "calc(100vh)" }}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <div className="meu_novo_componente">
                        <div className="title-search">
                            <h2>Pesquisa de Carrinhos</h2>
                            <svg
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={() => navigate(-1)}
                                style={{ cursor: "pointer" }}
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0.978551 2.21657L6.957 8.2395L0.978551 14.2624L2.97137 16.2701L8.94981 10.2471L14.9283 16.2701L16.9211 14.2624L10.9426 8.2395L16.9211 2.21657L14.9283 0.208931L8.94981 6.23186L2.97137 0.208931L0.978551 2.21657Z"
                                    fill="#636363"
                                />
                            </svg>
                        </div>
                        <div className="search-body-new" onScroll={checkBottom}>
                            <div className="search-inputs-vendor-new" >
                                <InputMask
                                    style={disableDoc ? { backgroundColor: "#D5D5D5" } : {}}
                                    mask={maskCpfjCnpj}
                                    type="text"
                                    value={customerDocument || ""}
                                    disabled={disableDoc}
                                    placeholder={
                                        config?.content.pdv && config?.content.pdv.allowSellCnpj
                                            ? "Número do CPF ou CNPJ"
                                            : "Número do CPF"
                                    }
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") searchOrders();
                                    }}
                                    onInput={(event) =>
                                        changeMaskCpf((event.target as HTMLInputElement).value)
                                    }
                                    onChange={(event) => {
                                        setCustomerDocument(event.target.value);
                                        if (event.target.value !== "") {
                                            setDisableNumber(true);
                                        } else {
                                            setDisableNumber(false);
                                        }
                                    }}
                                />
                            </div>

                            <div className="button-search-vendor">
                                <MainButton
                                    color={
                                        config?.webappcolor.fontbutton
                                            ? config.webappcolor.fontbutton
                                            : "#636363"
                                    }
                                    backgroundColor={
                                        config?.webappcolor.webappbutton
                                            ? config.webappcolor.webappbutton
                                            : "#EAEAEA"
                                    }
                                    text="Pesquisar"
                                    onClick={() => searchOrders()}
                                />
                            </div>
                            <div className="filter-options-div">
                                <button
                                    className="button-filter"

                                    onClick={() => {
                                        if (
                                            !(
                                                customerDocument &&
                                                (
                                                    cnpj.isValid(customerDocument) ||
                                                    cpf.isValid(customerDocument)
                                                )
                                            )
                                        ) {
                                            Swal.fire({
                                                icon: "warning",
                                                title: "Atenção!",
                                                text: "Informe um CPF ou CNPJ válido para filtrar.",
                                                confirmButtonText: "OK",
                                                showCancelButton: false,
                                            });
                                            return;
                                        }
                                        setOpenModalFiltroPedido(true);
                                    }}
                                >
                                    <p>Filtrar</p>
                                </button>

                                <div className="select-options"
                                    onBlur={(e) => {
                                        // Só dispara onBlur se o foco sair da div e não for para um elemento filho
                                        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                                            setDropdownOpen(false);
                                        }
                                    }}>
                                    <div
                                        className="selected-option"
                                        style={{
                                            borderRadius: isDropdownOpen ? "10px 10px 0 0 " : "10px",
                                            borderBottom: isDropdownOpen ? "none" : "",
                                        }}
                                        onClick={() => setDropdownOpen(!isDropdownOpen)}
                                        tabIndex={0}

                                    >
                                        <p>{orderType.name}</p>
                                    </div>
                                    {isDropdownOpen && (
                                        <div className="optionsDropdown">
                                            {orderTypes.map((option: OrdenationType) => (
                                                <div
                                                    key={option.name}
                                                    className="optionDropdown"
                                                    onClick={() => handleMaisRecentesSearchOrders(option)}
                                                    tabIndex={-1}
                                                >
                                                    <p>{option.name}</p>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div id="orders" className="orders-finded-new">
                                {vendorCarts.length > 0 &&
                                    vendorCarts.map((cart) => (
                                        <CustomerCartItem
                                            cart={cart}
                                            key={cart.guid}
                                            colorStatus={config?.webappcolor.backgroundstatus}
                                            colorActiveStatus={
                                                config?.webappcolor.backgroundstatusactive
                                            }
                                            fontStatus={config?.webappcolor.fontstatus}
                                            onUseCart={handleUseCart}
                                        />
                                    ))}

                                {vendorCarts.length === 0 && (
                                    <div className="no-product">
                                        <h2>Nenhum carrinho encontrado com os filtros aplicados</h2>
                                    </div>
                                )}
                            </div>
                        </div>
                        {isLoading && (
                            <>
                                <ReactLoading
                                    type="bubbles"
                                    color="#96969680"
                                    width={64}
                                    height={64}
                                />

                            </>
                        )

                        }


                    </div>
                )}
                {!loadingHeader && (
                    <Menu

                        fontColor={
                            config?.webappcolor.iconsfooter
                                ? config?.webappcolor.iconsfooter
                                : "#636363"
                        }
                        activeFontColor={
                            config?.webappcolor.highlightfooter
                                ? config?.webappcolor.highlightfooter
                                : "#000"
                        }
                        backgroundMenu={
                            config?.webappcolor.backgroundfooter
                                ? config?.webappcolor.backgroundfooter
                                : "#F5F5F5"
                        }
                        colorIcons={
                            config?.webappcolor.iconsfooter
                                ? config?.webappcolor.iconsfooter
                                : "#636363"
                        }
                        highlightColorIcons={
                            config?.webappcolor.highlightfooter
                                ? config?.webappcolor.highlightfooter
                                : "#636363"
                        }
                        backgroundCart={
                            config?.webappcolor.backgroundcart
                                ? config.webappcolor.backgroundcart
                                : "#FFBA49"
                        }
                        fontCart={
                            config?.webappcolor.fontcart
                                ? config.webappcolor.fontcart
                                : "#000"
                        }
                        noSales={
                            config &&
                                config?.content &&
                                config?.content.pdv &&
                                config?.content.pdv.noSales
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
            </div>

            <ModalFiltroPedidoVendedor setOpenModalFiltroOrder={setOpenModalFiltroPedido} openModalFiltroOrder={openModalFiltroPedido} config={config} isCustomerCart />
        </div>
    );
}
